import { isSolanaChain } from '@particle-network/connector-core';
import { useMemo } from 'react';
import ShareIconCircle from '../../assets/icons/ShareIconCircle';
import CopyToClipboard from '../../components/copyToClipboard';
import WalletAAIcon from '../../components/walletAAIcon';
import WalletIcon from '../../components/walletIcon';
import { useAccount } from '../../hooks/useAccount';
import { useAddress } from '../../hooks/useAddress';
import { useChains } from '../../hooks/useChains';
import { useSmartAccount } from '../../hooks/useSmartAccount';
import { shortAddress } from '../../utils';
import { StyleAddressInfo, StyleShareContent, TitleContainer } from './styles';

const Title = () => {
  const chainList = useChains();
  const { chainId: currentChainId } = useAccount();
  const smartAccount = useSmartAccount();
  const address = useAddress();

  // @ts-ignore
  const aaIconName = smartAccount?.smartAccountContract?.name?.toUpperCase();
  /**
   * get block explorer url
   */
  const blockExplorerUrl = useMemo(() => {
    if (!currentChainId || !address || !chainList) {
      return '';
    }

    const currentChain = chainList.find((chain) => chain.id === currentChainId);

    if (!currentChain || !currentChain.blockExplorers) {
      return '';
    }

    const explorerUrl = currentChain.blockExplorers.default.url;

    if (isSolanaChain(currentChain)) {
      return `${explorerUrl}/account/${address}`;
    }

    return `${explorerUrl}/address/${address}`;
  }, [currentChainId, address, chainList]);

  return (
    <TitleContainer>
      <StyleAddressInfo>
        {!!address && (
          <>
            {/* <WalletIconWrapper>{walletConnection?.walletProps.icon}</WalletIconWrapper> */}
            {aaIconName ? <WalletAAIcon size={26} aaName={aaIconName} /> : <WalletIcon size={26} />}
            <CopyToClipboard string={address}>{shortAddress(address || '--')}</CopyToClipboard>
            <StyleShareContent>
              <ShareIconCircle
                style={blockExplorerUrl ? { cursor: 'pointer' } : { cursor: 'not-allowed', opacity: 0.4 }}
                onClick={() => {
                  if (blockExplorerUrl) {
                    window.open(blockExplorerUrl, '_blank');
                  }
                }}
              />
            </StyleShareContent>
          </>
        )}
      </StyleAddressInfo>
    </TitleContainer>
  );
};

export default Title;
